import actions from '@/core/store/documentos/processo-digital/actions'
import desentranhamento from '@/core/store/documentos/processo-digital/desentranhamento'

export default {
	actions,
	modules: {
		desentranhamento,
	},
}
